// cost/costSeverity.ts
import type { CostTelemetry } from '../../../../types/council';

export const DIVERGENCE_RATIO_GATE = 0.25;
export const DIVERGENCE_ABS_GATE_USD = 0.005;

export function costSeverity(
  t: CostTelemetry | null | undefined,
  breached: boolean,
): { divergent: boolean; breached: boolean } {
  if (!t) return { divergent: false, breached };
  const est = parseFloat(t.cost_usd);
  const act = t.cost_actual_usd == null ? NaN : parseFloat(t.cost_actual_usd);
  const ratio = t.cost_divergence_ratio == null ? NaN : parseFloat(t.cost_divergence_ratio);
  const divergent =
    Number.isFinite(ratio) && Number.isFinite(est) && Number.isFinite(act) &&
    Math.abs(ratio) >= DIVERGENCE_RATIO_GATE &&
    Math.abs(est - act) >= DIVERGENCE_ABS_GATE_USD;
  return { divergent, breached };
}
